import {
  Box,
  Button,
  CurrencyInput,
  Form,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  Icon,
  Spacer,
  Text
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { SlideOnMount } from '../../../shared/Animations'
import { HomeownerDigestTrackingEventLocation } from '../../../../constants/tracking'

const Slide = props => <SlideOnMount interval={50} top='-80px' {...props} />

const MSG = defineMessages({
  heading: {
    id: 'HomePriceIndexWizard.steps.bestGuess.heading',
    defaultMessage: 'How much do you think your home may be worth today?'
  },
  subheading: {
    id: 'HomePriceIndexWizard.steps.bestGuess.subheading',
    defaultMessage: "You're so close to seeing your home's estimated value and equity insights!"
  },
  submit: {
    id: 'HomePriceIndexWizard.steps.bestGuess.submit',
    defaultMessage: 'Crunch the numbers'
  },
  bestGuessLabel: {
    id: 'HomePriceIndexWizard.steps.bestGuess.bestGuessLabel',
    defaultMessage: 'Current Estimated Value'
  },
  bestGuessRequiredError: {
    id: 'HomePriceIndexWizard.steps.bestGuess.bestGuessRequiredError',
    defaultMessage: "Enter a guess for your home's worth"
  }
})

export const BestGuess = ({ onComplete }) => {
  const intl = useIntl()

  return (
    <Form onSubmit={onComplete} flex='1' display='flex' flexDirection='column' justifyContent='space-between'>
      {({ formState: { errors } }) => (
        <>
          <Slide>
            <Heading>{intl.formatMessage(MSG.heading)}</Heading>
            <Text>{intl.formatMessage(MSG.subheading)}</Text>
          </Slide>
          <Slide>
            <Box marginTop='12'>
              <FormControl isInvalid={!!errors?.baseValue}>
                <FormLabel>{intl.formatMessage(MSG.bestGuessLabel)}</FormLabel>
                <CurrencyInput
                  name='baseValue'
                  rules={{
                    required: {
                      value: true,
                      message: intl.formatMessage(MSG.bestGuessRequiredError)
                    }
                  }}
                  tracking={{
                    guid: 'hkWy2sMFYYn9q9t6R6Ty1c',
                    descriptor: MSG.bestGuessLabel.defaultMessage,
                    ui_context:
                      HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_BEST_GUESS_STEP
                  }}
                />
                <FormErrorMessage>{errors?.baseValue?.message?.toString()}</FormErrorMessage>
              </FormControl>
            </Box>
          </Slide>
          <Spacer />
          <Slide>
            <Button
              width='100%'
              colorScheme='primary'
              type='submit'
              rightIcon={<Icon name='calculator' />}
              tracking={{
                guid: 'aadRFVSY1LMhHHQDiApw8p',
                descriptor: MSG.submit.defaultMessage,
                ui_context:
                  HomeownerDigestTrackingEventLocation.HOMEOWNER_DIGEST_HOME_PRICE_INDEX_WIZARD_BEST_GUESS_STEP
              }}
            >
              {intl.formatMessage(MSG.submit)}
            </Button>
          </Slide>
        </>
      )}
    </Form>
  )
}
